import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SelectComponent } from '../../Components/shared/ReusableSmallComponents';
import { urlListeSideBarDocAdministraExpert } from '../../data/Interfaces';
import useWindowSize from '../../hooks/useWindowSize';

const menuglobalstyle = {
    //marginLeft: '25px',
    boxSizing: 'border-box',
    display: 'flex',
    height: 'fit-content',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '16px',
    gap: '4px',
    background: '#FFFFFF',
    border: '1px solid #7083DD',
    borderRadius: '10px',
};

function DocAdministra() {
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const {device}=useWindowSize();
    const navigate = useNavigate();
    const [urlPage,setUrlPage]=useState('');
    const { i18n } = useTranslation();

    useEffect(() => {
        console.log('path',pathname);
    });

    useEffect(() => {
        if(pathname){
            setUrlPage(pathname);
        }

    },[pathname]);

    const handleChangeUrl = async (e) => {
        const newUrl = e.target.value;
        await setUrlPage(newUrl);
        navigate(newUrl, { replace: true });
    };
    return (
        <div style={{display:'flex',flexDirection:'column',gap:'20px',alignSelf:'stretch',paddingLeft: device=='desktop'?'24px':'0px'}}>
            <div className='frame5Profile'>{i18n.t('Mon compte')}   &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Documents administratifs')} </span> </div>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'20px',alignSelf:'stretch'}}>
                {device=='desktop' ?
                    <div style = {menuglobalstyle}>
                        <div
                            className={currentPath == 'docAdministrative' ? 'kbismenustyle fiscalselectedmenustyle' : 'kbismenustyle'}
                        >
                            <Link
                                to="."
                                style={{ textDecoration: 'none' }}
                            >
                                <p className={currentPath == 'docAdministrative' ? 'textotherstyle textcardidstyle' : 'textotherstyle'}>{i18n.t('Pièce d\'identité')}</p>
                            </Link>
                        </div>

                        <div
                            className={currentPath == 'kbis' ? 'kbismenustyle fiscalselectedmenustyle' : 'kbismenustyle'}
                        >
                            <Link
                                to="kbis"
                                style={{ textDecoration: 'none' }}
                            ><p className={currentPath == 'kbis' ? 'textotherstyle textcardidstyle' : 'textotherstyle'}>{i18n.t('Kbis')}</p>
                            </Link>
                        </div>

                        <div
                            className={currentPath == 'attestationFiscale' ? 'kbismenustyle fiscalselectedmenustyle' : 'kbismenustyle'}
                        >
                            <Link
                                to="attestationFiscale"
                                style={{ textDecoration: 'none' }}
                            >
                                <p className={currentPath == 'attestationFiscale' ? 'textotherstyle textcardidstyle' : 'textotherstyle'}>{i18n.t('Attestation fiscale')}</p>
                            </Link>
                        </div>

                        <div
                            className={currentPath == 'attestationUrssaf' ? 'kbismenustyle fiscalselectedmenustyle' : 'kbismenustyle'}
                        >
                            <Link
                                to="attestationUrssaf"
                                style={{ textDecoration: 'none' }}
                            ><p className={currentPath == 'attestationUrssaf' ? 'textotherstyle textcardidstyle' : 'textotherstyle'}>{i18n.t('Attestation Urssaf')}</p>
                            </Link>
                        </div>

                        <div
                            className={currentPath == 'assurance' ? 'kbismenustyle fiscalselectedmenustyle' : 'kbismenustyle'}
                        >
                            <Link
                                to="assurance"
                                style={{ textDecoration: 'none' }}
                            ><p className={currentPath == 'assurance' ? 'textotherstyle textcardidstyle' : 'textotherstyle'}>{i18n.t('Assurance')}</p>
                            </Link>
                        </div>

                        <div className={currentPath == 'contratHTH' ? 'kbismenustyle fiscalselectedmenustyle' : 'kbismenustyle'}>
                            <Link
                                to="contratHTH"
                                style={{ textDecoration: 'none' }}
                            >
                                <p className={currentPath == 'contratHTH' ? 'textotherstyle textcardidstyle' : 'textotherstyle'}>{i18n.t('Contrat HTH')}</p>
                            </Link>
                        </div>

                        <div className={currentPath == 'attestationHonneur' ? 'kbismenustyle fiscalselectedmenustyle' : 'kbismenustyle'}>

                            <Link
                                to="attestationHonneur"
                                style={{ textDecoration: 'none' }}
                            ><p className={currentPath == 'attestationHonneur' ? 'textotherstyle textcardidstyle' : 'textotherstyle'}>{i18n.t('Attestation sur l\'honneur')}</p>
                            </Link>
                        </div>
                    </div>
                    :
                    <div style={{widt:'100%',minWidth:'200px',maxWidth:'500px'}}>
                        <SelectComponent
                            val={urlPage}
                            setVal={(e) => handleChangeUrl(e)}
                            listVal={urlListeSideBarDocAdministraExpert}
                        />
                    </div>
                }

                <div
                    style={{display:'flex',flexDirection:'column',alignSelf:'stretch',width: device=='desktop'?'85%':'100%',
                        alignItems: 'center'}}
                >
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default DocAdministra;